import { Component } from '@angular/core';
import { UtilityService } from 'src/app/shared/services/utility.service';

@Component({
  selector: 'app-device-support',
  templateUrl: './device-support.component.html',
  styleUrls: ['./device-support.component.scss'],
})
export class DeviceSupportComponent {
  constructor(private utilityService: UtilityService) {}

  /**
   * Redirects to end of life link for Android version support details.
   */
  openEndOfLifeLink(): void {
    this.utilityService.openExternalLink('https://endoflife.date/android');
  }
}
